<template>
  <div class="notice-modal" v-if="noticeState.visible" @click="handleBackdropClick">
    <div class="notice-content" @click.stop>
      <!-- 头部 -->
      <div class="notice-header">
        <h3 class="notice-title">{{ noticeState.title }}</h3>
        <button 
          v-if="canClose" 
          class="close-btn" 
          @click="handleClose"
          :title="closeable ? '关闭' : '版本维护中，无法关闭'"
        >
          <img src="@/assets/close.png" alt="关闭" />
        </button>
      </div>
      
      <!-- 内容区域 -->
      <div class="notice-body">
        <!-- <div class="notice-type-icon">
          <img :src="typeIcon" :alt="noticeTypeName" />
        </div> -->
        <div class="notice-text">
          <div class="notice-description" v-html="noticeState.content"></div>
        </div>
      </div>
      
      <!-- 底部操作区 -->
      <div class="notice-footer" v-if="noticeState.showFooter">
        <button 
          v-if="canClose" 
          class="confirm-btn" 
          @click="handleConfirm"
        >
          {{ noticeState.confirmText }}
        </button>
        <div v-else class="maintenance-tip">
          系统维护中，请耐心等待...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NoticeMark',
  computed: {
    ...mapGetters('notice', ['noticeState', 'isCloseable']),
    // 是否可关闭（更新日志可关闭，版本维护不可关闭）
    closeable() {
      return this.noticeState.noticeType === 'update'
    },
    // 是否显示关闭按钮
    canClose() {
      return this.closeable
    },
    // 通知类型名称
    noticeTypeName() {
      return this.noticeState.noticeType === 'update' ? '更新通知' : '维护通知'
    },
    // 通知类型图标
    typeIcon() {
      return this.noticeState.noticeType === 'update' 
        ? require('@/assets/warningsIcon.png')
        : require('@/assets/warningsIcon.png')
    }
  },
  methods: {
    // 处理关闭
    handleClose() {
      if (this.closeable) {
        this.$store.dispatch('notice/hideNotice')
      }
    },
    // 处理确认
    handleConfirm() {
      this.$store.dispatch('notice/confirmNotice')
    },
    // 处理背景点击
    handleBackdropClick() {
      if (this.closeable && this.noticeState.backdropCloseable) {
        this.handleClose()
      }
    }
  }
}
</script>

<style scoped>
.notice-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.notice-content {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  overflow-x: hidden; /* 防止横向滚动 */
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.notice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.notice-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: white;
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.close-btn img {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

.notice-body {
  padding: 24px;
  display: flex;
  gap: 16px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden; /* 防止横向滚动 */
}

.notice-type-icon {
  flex-shrink: 0;
}

.notice-type-icon img {
  width: 40px;
  height: 40px;
}

.notice-text {
  flex: 1;
}

.notice-description {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  word-wrap: break-word;
  overflow-wrap: break-word;
  /* white-space: pre-wrap; */
}

.notice-description ::v-deep h1,
.notice-description ::v-deep h2,
.notice-description ::v-deep h3 {
  margin: 16px 0 8px;
  color: #333;
}

.notice-description ::v-deep ul,
.notice-description ::v-deep ol {
  margin: 8px 0;
  padding-left: 20px;
}

.notice-description ::v-deep li {
  margin: 4px 0;
}

.notice-footer {
  padding: 16px 24px 24px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #f0f0f0;
  background-color: #fafafa;
}

.confirm-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 100px;
}

.confirm-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.confirm-btn:active {
  transform: translateY(0);
}

.maintenance-tip {
  color: #666;
  font-size: 14px;
  text-align: center;
  font-style: italic;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .notice-content {
    width: 95%;
    margin: 20px;
  }
  
  .notice-header {
    padding: 16px 20px 12px;
  }
  
  .notice-title {
    font-size: 16px;
  }
  
  .notice-body {
    padding: 20px;
    gap: 12px;
  }
  
  .notice-type-icon img {
    width: 32px;
    height: 32px;
  }
  
  .notice-footer {
    padding: 12px 20px 20px;
  }
}
</style>